// git hb columns for issues
const COLUMNS = [
    {
        id: 2352456,
        isOpen: true,
        name: 'Backlog',
    },
    {
        id: 2352457,
        isOpen: true,
        name: 'Doing',
    },
    {
        id: 2352458,
        isOpen: true,
        name: 'Testing',
    },
    {
        id: 2352460,
        isOpen: false,
        name: 'Merged',
    },
    {
        id: 2352461,
        isOpen: false,
        name: 'Deployed',
    },
];

const ENV_SETTINGS = {
    DEV: {
        icon: 'images/gear.png',
        name: 'DEV',
        url: 'https://lumsites-dev.appspot.com/',
    },
    DEV2: {
        icon: 'images/two.png',
        name: 'DEV2',
        url: 'https://lumsites-dev2.appspot.com/',
    },
    EU: {
        icon: 'images/europe.png',
        name: 'EU',
        url: 'https://sites-eu.lumapps.com/',
    },
    GBL: {
        icon: 'images/veolia.png',
        name: 'GBL',
        url: 'https://gbl-imt-ve-o2o.appspot.com/',
    },
    SANDBOX: {
        icon: 'images/sandbox.png',
        name: 'SANDBOX',
        url: 'https://lumsites-sandbox.appspot.com/',
    },
    US: {
        icon: 'images/logo-color.png',
        name: 'US',
        url: 'https://sites.lumapps.com/',
    },
    MICROSOFT: {
        icon: 'images/microsoft.png',
        name: 'MICROSOFT',
        url: 'https://sites-ms.lumapps.com/',
    },
};

const GRAPH_URLS = {
    BACK: [
        'https://datastudio.google.com/embed/reporting/1kFFs5UOnZ9HGUmShPvxG4_2CivTfeigR/page/64nQ',
        'https://datastudio.google.com/embed/reporting/1kFFs5UOnZ9HGUmShPvxG4_2CivTfeigR/page/HpoQ',
        'https://datastudio.google.com/embed/reporting/1kFFs5UOnZ9HGUmShPvxG4_2CivTfeigR/page/vroQ',
        'https://datastudio.google.com/embed/reporting/1ODACv7-IQBcogfJheaKqG8gZVHEYGjHn/page/zZ8R',
    ],
    FRONT: [
        'https://public.google.stackdriver.com/public/chart/5077009525485918168?drawMode=stats&showLegend=false&theme=dark&autoRefresh=true&timeframe=1w',
        'https://public.google.stackdriver.com/public/chart/8708048429276051562?drawMode=stats&showLegend=false&theme=dark&autoRefresh=true&timeframe=1w',
        'https://public.google.stackdriver.com/public/chart/15154982661649758621?drawMode=stats&showLegend=false&theme=dark&autoRefresh=true&timeframe=1w',
    ],
};

// Defines the number of items per row
const GRAPHS_PER_ROW = 3;
const CARDS_PER_ROW = 5;

//Info for TCL Service
const TCL_AUTH_TOKEN = 'Z3JlZ29yeS5jYXQuZ2NAZ21haWwuY29tOkx1bUBwcHMxMjM=';
const TCL_BASE_URL = 'https://download.data.grandlyon.com/ws/rdata/';
const TCL_ALL_ARRET_URL = `${TCL_BASE_URL}tcl_sytral.tclpassagearret/all.json`;

// Time in hours we want to keep user in local storage before invalid it.
const LOCAL_STORAGE_TTL = 1;

module.exports = {
    COLUMNS,
    ENV_SETTINGS,
    GRAPH_URLS,
    GRAPHS_PER_ROW,
    LOCAL_STORAGE_TTL,
    CARDS_PER_ROW,
    TCL_AUTH_TOKEN,
    TCL_BASE_URL,
    TCL_ALL_ARRET_URL,
};



// WEBPACK FOOTER //
// ./src/constants.js